export const loadAsyncScript = (url: string): Promise<void> =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    document.head.appendChild(script);

    script.onload = (): void => {
      resolve();
    };

    script.onerror = (): void => {
      reject(new Error('Unable to load the script'));
    };
  });

export const loadSyncScript = (url: string): void => {
  const xhttp = new XMLHttpRequest();
  xhttp.open('GET', url, false);
  xhttp.send(null);

  const headTag = document.getElementsByTagName('head')[0];
  const scriptTag = document.createElement('script');
  scriptTag.type = 'text/javascript';
  scriptTag.text = xhttp.responseText;
  headTag.appendChild(scriptTag);
};
